import { Component, Input, ViewChild } from '@angular/core';
import { ProvidersService } from 'fccore2'; 
import { FormGroup, FormBuilder } from '@angular/forms';
import { FcinputComponent } from '../fcinput';
import { FcmodallistComponent } from './fcmodallist.component'; 
import { FCEVENT } from '../fc'; 
import { SysappfieldDic, Sysappfields, Sysappbuttons } from 'fccore2';
import { CommonService } from 'fccore2';
import { SEARCHLAYOUT, SEARCHACTION } from '../business/fclistdata.business';
@Component({
    selector: 'fc-modallistsearch',
    template: `
    <fc-layoutpanel class="fc-listsearch" *ngIf="fcModalSearchConfig.fcValidate!==undefined&&fcModalSearchConfig.fcFields.length!==0">
        <div fccontent>
            <form nz-form  [formGroup]="fcModalSearchConfig.fcValidate">
                <div nz-row>
                    <div nz-col [nzSpan]="fcModalSearchConfig.fcSpans" nz-form-item *ngFor="let field of fcModalSearchConfig.fcFields">
                        <div nz-form-control>
                            <div nz-form-label nz-col [nzSm]="10" [nzXs]="24">
                                <label [for]="field.APPID+field.FIELDCODE">{{field.FIELDNAME}}</label>
                            </div>
                            <div nz-form-control nz-col [nzSm]="12" [nzXs]="24">
                                <fc-text fcShowLabel="Y" [formControlName]="field.FIELDCODE" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.DBTYPE==='STR'&&field.INPUTTYPE==='text'" ></fc-text>
                                <fc-double fcShowLabel="Y"  [formControlName]="field.FIELDCODE" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.DBTYPE==='NUM'&&field.SCALE!=='0'" ></fc-double>
                                <fc-long fcShowLabel="Y"  [formControlName]="field.FIELDCODE" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.DBTYPE==='NUM'&&field.SCALE==='0'" ></fc-long>
                                <fc-radio fcShowLabel="Y"  [formControlName]="field.FIELDCODE" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.INPUTTYPE==='radio'&&fcModalSearchConfig.fcFieldDics[field.FIELDCODE].DICTYPE==='LISTVALUE'"  [fcOption]="fcModalSearchConfig.fcFieldDics[field.FIELDCODE].SYSAPPDICDETAIL" fcValueCode='DICVALUE' fcLabelCode='DICDESC'></fc-radio>
                                <fc-check fcShowLabel="Y"  [formControlName]="field.FIELDCODE" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.INPUTTYPE==='check'&&fcModalSearchConfig.fcFieldDics[field.FIELDCODE].DICTYPE==='LISTVALUE'"  [fcOption]="fcModalSearchConfig.fcFieldDics[field.FIELDCODE].SYSAPPDICDETAIL" fcValueCode='DICVALUE' fcLabelCode='DICDESC'></fc-check>
                                <fc-combo fcShowLabel="Y"  [formControlName]="field.FIELDCODE" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.INPUTTYPE==='combo'&&fcModalSearchConfig.fcFieldDics[field.FIELDCODE].DICTYPE==='LISTVALUE'"  [fcOption]="fcModalSearchConfig.fcFieldDics[field.FIELDCODE].SYSAPPDICDETAIL" fcValueCode='DICVALUE' fcLabelCode='DICDESC'></fc-combo>
                                <fc-chosen fcShowLabel="Y"  [formControlName]="field.FIELDCODE" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.INPUTTYPE==='chosen'&&fcModalSearchConfig.fcFieldDics[field.FIELDCODE].DICTYPE==='LISTVALUE'"  [fcOption]="fcModalSearchConfig.fcFieldDics[field.FIELDCODE].SYSAPPDICDETAIL" fcValueCode='DICVALUE' fcLabelCode='DICDESC'></fc-chosen>
                                <fc-text fcShowLabel="Y"  [formControlName]="field.FIELDCODE" [fcAddonAfter]="'anticon anticon-search'" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.DBTYPE==='STR'&&field.INPUTTYPE.indexOf('queryselect')!==-1" (fcEvent)="_search($event,field,fcModalSearchConfig.fcFieldDics[field.FIELDCODE].SYSAPPDICAPP)">
                                </fc-text>                                
                                <fc-textarea fcShowLabel="Y"  [formControlName]="field.FIELDCODE" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.INPUTTYPE==='textarea'" ></fc-textarea>
                            </div>
                        </div>
                    </div>
                    <fc-tlbform [fcButtons]="fcModalSearchConfig.fcToolbar" (fcEvent)="_event($event)"></fc-tlbform>
                </div>
                <fc-modallist #FcmodallistsearchComponent [fcTitle]="_modalOption.fcTitle" [fcCondition]="_modalOption.fcCondition" [fcAppid]="_modalOption.fcAppid" [fcType]="_modalOption.fcType" (fcEvent)="_modalClose($event)"></fc-modallist>
            </form>
        </div>
    </fc-layoutpanel>
    `,
    styles: [`
    .fc-modallistsearch{
        width:100%;
    }
    .fc-modallistsearch-label {
        display:block;
        padding-right:10px;
        text-align:right;
    }
    :host ::ng-deep .ant-form-item{
        margin-bottom:0;
    }
    `]
})
export class FcmodallistsearchComponent extends FcinputComponent {
    @ViewChild('FcmodallistsearchComponent', {static: false})
    modalList: FcmodallistComponent;
     /** å­æ®µå*/
    @Input()
    fcModalSearchConfig: FcmodallistsearchConfig;
    _modalOption: FcmodallistsearchmodalOption;
    private _tempCopyInfo: any = {};
    constructor(public provider: ProvidersService, private fb: FormBuilder) {
        super(provider, 'fc-modallistsearch');
        this._modalOption = { fcAppid: '', fcTitle: '', fcType: '', fcCondition: '{}' }
    }
    /**
     * ç¶çº§åå§åå®æåæ§è¡æ¹æ³
     */
    _afterParentInit() {
        this.fcModalSearchConfig.fcLayout = SEARCHLAYOUT.HORIZONTAL;
        this.fcModalSearchConfig.fcFields = [];
        if (this.fcAppid !== undefined) {
            this.fcModalSearchConfig.fcFields = this.fcApp.SYSAPPFIELDS.filter(item => item.ENABLESEARCH === 'Y');
            let validateForm: any = {};
            this.fcModalSearchConfig.fcFields.forEach(field => {
                let value = null;
                if (this.fcMainObj !== undefined) {
                    value = this.fcMainObj[field.FIELDCODE];
                }
                validateForm[field.FIELDCODE] = [value];
            });
            this.fcModalSearchConfig.fcValidate = this.fb.group(validateForm);
            const dicObj: any = {};
            this.fcModalSearchConfig.fcFields.filter(field => field.DICCODE !== undefined && field.DICCODE !== null && field.DICCODE !== '').forEach(item => {
                const fieldDic: SysappfieldDic = {};
                const dicList = this.fcApp.SYSDIC.filter(dic => dic.DICID === item.DICCODE);
                if (dicList.length !== 0) {
                    fieldDic.DICID = dicList[0].DICID;
                    fieldDic.DICTYPE = dicList[0].DICTYPE;
                    fieldDic.FIELDCODE = item.FIELDCODE;
                    if (fieldDic.DICTYPE === 'LISTAPP') {
                        fieldDic.SYSDICAPP = dicList[0].SYSDICAPP;
                    } else {
                        fieldDic.SYSDICDETAIL = dicList[0].SYSDICDETAIL;
                    }
                }
                dicObj[item.FIELDCODE] = fieldDic;
            });
            this.fcModalSearchConfig.fcFieldDics = dicObj;
            this.fcModalSearchConfig.fcToolbar = [{
                BTNTYPE: 'SEARCH',
                BTNICON: '',
                ACTCODE: 'search',
                BTNCODE: 'search',
                SORT: '0',
                ENABLE: 'Y',
                APPID: '',
                QUICKKEYS: '',
                BTNNAME: 'æ¥è¯¢',
                ID: '1',
            }, {
                BTNTYPE: 'SEARCH',
                BTNICON: '',
                ACTCODE: 'reset',
                BTNCODE: 'reset',
                SORT: '1',
                ENABLE: 'Y',
                APPID: '',
                QUICKKEYS: '',
                BTNNAME: 'éç½®',
                ID: '0',
            }]
        }
        this.fcModalSearchConfig.fcSpans = 8;
    }
    _search(event: any, field: any, dicApp: any) {
        this._tempCopyInfo.DICAPP = dicApp;
        this._tempCopyInfo.FIELD = field;
        this._modalOption.fcAppid = dicApp.APPID;
        this._modalOption.fcTitle = 'è¯·éæ©' + field.FIELDNAME;
        if (field.INPUTTYPE === 'queryselectmutiple') {
            this._modalOption.fcType = 'mutiple';
        } else {
            this._modalOption.fcType = 'sinple';
        }
        if (dicApp.APPFILTER !== undefined && dicApp.APPFILTER !== '' && dicApp.APPFILTER !== 'null') {
            let str = dicApp.APPFILTER.trim();
            let condition = str.toUpperCase().indexOf('AND') !== -1 ? str.substr(3, str.length) : str;
            this._modalOption.fcCondition = '{"WHERE":"' + CommonService.getStringFilterByParam(this.fcMainObj, condition) + '"}';
        }
        this.modalList.fcAppid = dicApp.APPID;
        this.modalList.fcTitle = this._modalOption.fcTitle;
        this.modalList.fcCondition = this._modalOption.fcCondition;
        this.modalList.fcType = this._modalOption.fcType;
        this.modalList.showModal();
    }
    _modalClose(event: FCEVENT) {
        if (event.eventName === 'success') {
            let value = "";
            event.param.forEach(item => {
                value += item[this._tempCopyInfo.DICAPP.FIELDCODE] + ",";
            });
            if (value !== '') {
                value = value.substr(0, value.length - 1);
            }
            this.fcModalSearchConfig.fcValidate.controls[this._tempCopyInfo.FIELD.FIELDCODE].setValue(value);
        }
    }
    /**
     * 
     * @param  äºä»¶æé®
     */
    _event($event: FCEVENT) {
        let searchValue: any = {};
        switch ($event.eventName) {
            case 'search':
                Object.keys(this.fcModalSearchConfig.fcValidate.value)
                    .forEach(key => {
                        this.fcMainObj[key] = this.fcModalSearchConfig.fcValidate.value[key];
                        if (this.fcMainObj[key] !== undefined && this.fcMainObj[key] !== null && this.fcMainObj[key].length !== 0) {
                            searchValue[key] = this.fcMainObj[key];
                        }
                    });
                this.event( "search", searchValue );
                break;
            case 'reset':
                Object.keys(this.fcModalSearchConfig.fcValidate.controls).forEach(key => {
                    this.fcModalSearchConfig.fcValidate.controls[key].setValue('');
                });
                this.event("reset", {} );
                break;
        }
    }

    _getFormControl(name): any {
        return this.fcModalSearchConfig.fcValidate.controls[name];
    }

}
export interface FcmodallistsearchConfig {
     /**è¡¨åæ é¢*/
    fcTitle?: string;
     /**è¡¨åå¯æ é¢*/
    fcSubTitle?: string;
    fcFields?: Sysappfields[];
     /** è¡¨åéç½®*/
    fcToolbar?: Sysappbuttons[];
    fcFieldDics?: any;
    fcAct?: SEARCHACTION;
    fcLayout?: string;
    fcValidate?: FormGroup;
     /**ååæ°*/
    fcSpans?: number;
}
export interface FcmodallistsearchmodalOption {
    fcAppid: string;
    fcTitle: string;
    fcType: string;
    fcCondition: string;
}